import apiClient from './apiClient';

export const subscriptionsApi = {
	// Get current user's subscription
	getCurrent: async () => {
		try {
			const response = await apiClient.get('/api/subscriptions/current');
			return response.data;
		} catch (error) {
			console.error('Error fetching current subscription:', error);
			throw new Error(
				error.response?.data?.message ||
					'Failed to retrieve subscription'
			);
		}
	},

	// Get organization's subscription
	getOrganizationSubscription: async (organizationId) => {
		try {
			const token = localStorage.getItem('authToken');

			const response = await apiClient.get(
				`/api/subscriptions/organization/${organizationId}`
			);
			return response.data;
		} catch (error) {
			console.error('Error fetching organization subscription:', error);
			console.error('Response status:', error.response?.status);
			console.error('Response data:', error.response?.data);

			// Don't throw error for 401 - just return empty data
			if (error.response?.status === 401) {
				return { subscription: null };
			}

			throw new Error(
				error.response?.data?.message ||
					'Failed to retrieve organization subscription'
			);
		}
	},

	// Create a subscription for an organization
	createOrganizationSubscription: async (organizationId, data) => {
		try {
			const response = await apiClient.post(
				`/api/subscriptions/organization/${organizationId}`,
				data
			);
			return response.data;
		} catch (error) {
			console.error('Error creating organization subscription:', error);
			throw new Error(
				error.response?.data?.message ||
					'Failed to create organization subscription'
			);
		}
	},

	// Cancel an organization's subscription
	cancelOrganizationSubscription: async (organizationId) => {
		try {
			const response = await apiClient.post(
				`/api/subscriptions/organization/${organizationId}/cancel`,
				{}
			);
			return response.data;
		} catch (error) {
			console.error('Error canceling organization subscription:', error);
			throw new Error(
				error.response?.data?.message ||
					'Failed to cancel organization subscription'
			);
		}
	},

	// Update subscription details
	updateSubscription: async (organizationId, data) => {
		try {
			const response = await apiClient.put(
				`/api/subscriptions/organization/${organizationId}`,
				data
			);
			return response.data;
		} catch (error) {
			console.error('Error updating subscription:', error);
			throw new Error(
				error.response?.data?.message || 'Failed to update subscription'
			);
		}
	},

	// Add an addon to an organization's subscription
	addAddon: async (organizationId, data, immediateCharge = false) => {
		try {
			const requestData = {
				...data,
				immediateCharge: immediateCharge,
			};

			const response = await apiClient.post(
				`/api/subscriptions/organization/${organizationId}/addon`,
				requestData
			);
			return response.data;
		} catch (error) {
			console.error('Error adding addon:', error);
			throw new Error(
				error.response?.data?.message || 'Failed to add addon'
			);
		}
	},
};
